import {ROUTE_PATHS} from "Config/Router/Routes";
import {UserRoleIds} from "../../Model/User/UserRoles";

export const ADMIN_MENU = [
    {
        "title": "Inicio",
        "path": ROUTE_PATHS.DASHBOARD,
    },
    {
        "roles" : [UserRoleIds.ADMIN],
        "title": "Personas",
        "path" : "#",
        "children" : [
            {
                "title": "Tutores",
                "path" : ROUTE_PATHS.ADMIN_TUTOR_LIST
            },
            {
                "title": "Niños/as",
                "path" : ROUTE_PATHS.ADMIN_KIDS_LIST
            },
            {
                "title": "Usuarios",
                "path" : ROUTE_PATHS.ADMIN_USER_LIST
            },
            {
                "title": "Necesidades individuales",
                "path" : ROUTE_PATHS.ADMIN_SPECIAL_NEEDS_LIST
            }
        ]
    },
    {
        "roles" : [UserRoleIds.ADMIN],
        "title" : "Solicitudes",
        "path" : ROUTE_PATHS.ADMIN_INSCRIPTION_LIST
    },
    {
        "roles" : [UserRoleIds.ADMIN],
        "title" : "Gestión",
        "path" : "#",
        "children" : [
            {
                "title": "Inscripciones",
                "path" : ROUTE_PATHS.ADMIN_ACTIVITIES_LIST
            },
            {
                "title": "Actividades",
                "path" : ROUTE_PATHS.ADMIN_MODALITIES_LIST
            },
            {
                "title": "Matrículas",
                "path" : ROUTE_PATHS.ADMIN_ENROLLMENTS_LIST
            },
            {
                "title": "Centros",
                "path" : ROUTE_PATHS.ADMIN_CENTERS_LIST
            },
            {
                "title": "Cursos",
                "path" : ROUTE_PATHS.ADMIN_COURSES_LIST
            },
            {
                "title": "Modificaciones de cuota mensual",
                "path" : ROUTE_PATHS.ADMIN_MONTHLY_FEE_MODIFICATION_LIST
            },
            {
                "title": "Recibos",
                "path" : ROUTE_PATHS.ADMIN_RECEIPTS_LIST
            },
            {
                "title": "Códigos SWIFT",
                "path" : ROUTE_PATHS.ADMIN_BANK_SWIFT_CODES_LIST
            },
            {
                "title": "Transacciones TPV",
                "path" : ROUTE_PATHS.ADMIN_TPV_TRANSACTIONS_LIST
            },
            {
                "title": "Configuración",
                "path" : ROUTE_PATHS.ADMIN_CONFIG_LIST
            }
        ]
    },
    {
        "title" : "Informes",
        "path" : ROUTE_PATHS.ADMIN_REPORT_LIST,
        "roles" : [UserRoleIds.ADMIN]
    },
    {
        "title" : "Financiero",
        "roles" : [UserRoleIds.ADMIN, UserRoleIds.FINANCE],
        "path" : "#",
        "children" : [
            {
                "title": "Listado de gastos",
                "path" : ROUTE_PATHS.ADMIN_FINANCE_LIST
            },
            {
                "title": "Importar gastos",
                "path" : ROUTE_PATHS.ADMIN_FINANCE_IMPORT
            },
            {
                "title": "Informe rendimiento económico",
                "path" : ROUTE_PATHS.ADMIN_FINANCE_REVENUE
            }
        ]
    },
]
